import React from "react";

// Admin Imports
import Dashboard from "views/console/default";
import Profile from "views/admin/profile";

// Auth Imports
import SignIn from "views/auth/SignIn";
import AdminSignIn from "views/auth/AdminSignIn";
import Register from "views/auth/Register";
import ScanQR from "views/auth/ScanQR";
import HomeScreen from "views/home/HomeScreen";

// Icon Imports
import { HomeOutlined, SettingOutlined, 
  LockOutlined, ProductOutlined,
  FolderViewOutlined, ApartmentOutlined 
} from '@ant-design/icons';

import usersRoutes from "views/console/users/routes";
import moduleRoutes from "views/console/modules/routes";
import accessRightsRoutes from "views/console/access-rights/routes";
import parametersRoutes from "views/console/parameters/routes";
import rolesRoutes from "views/console/roles/routes";
import accountRoutes from "views/console/accounts/routes";
import breedingEventRoutes from "views/console/breeding-events/routes";

import animalInventoryRoutes from "views/console/animal-inventory/routes";
import registeredAnimalRoutes from "views/console/registered-animals/routes";

import ManualRegister from "views/auth/ManualRegister";
import { MODULE_DASHBOARD, MODULE_BREEDING_EVENT,
  MODULE_ACCESS_MANAGEMENT, MODULE_SETTINGS,
 } from "variables/constants";


const routes = [
  {
    name: "Home",
    layout: "/home",
    path: "/",
    component: <HomeScreen />,
    isMainMenu:false,
  },
  {
    name: "Scan QR",
    layout: "/auth",
    path: "home",
    component: <ScanQR />,
    isMainMenu:false,
  },
  {
    name: "Register",
    layout: "/auth",
    path: "register",
    component: <Register />,
    isMainMenu:false,
  },
  {
    name: "Manual Register",
    layout: "/auth",
    path: "manual-register",
    component: <ManualRegister />,
    isMainMenu:false,
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    component: <SignIn />,
    isMainMenu:false,
  },
  {
    name: "Admin Sign In",
    layout: "/auth",
    path: "base/sign-in",
    component: <AdminSignIn />,
    isMainMenu:false,
  },
  {
    name: "Power Admin Sign In",
    layout: "/auth",
    path: "pad/sign-in",
    component: <AdminSignIn />,
    isMainMenu:false,
  },
  {
    name: "Dashboard",
    layout: "/console",
    path: "dashboard",    
    component: <Dashboard />,
    isMainMenu:true,
    icon: <HomeOutlined className="h-6 w-6" />,
    level: 3,
    moduleId: MODULE_DASHBOARD,
  },
  ...animalInventoryRoutes,
  ...registeredAnimalRoutes,
  {
    name: "Breeding Events",
    layout: "/console",
    path: "#",    
    component: null,
    isMainMenu:true,
    icon: <ApartmentOutlined className="h-6 w-6"/>,
    level: 4,
    moduleId: MODULE_BREEDING_EVENT,
    children: [
      ...breedingEventRoutes,
    ]
  },
  ...accountRoutes,
  {
    name: "Settings",
    layout: "/console",
    path: "#",    
    component: null,
    isMainMenu:false,
    icon: <SettingOutlined className="h-6 w-6"/>,
    level: 1,
    moduleId: MODULE_SETTINGS,
    children: [
      ...parametersRoutes,  
    ]
  },
  {
    name: "Access Management",
    layout: "/console",
    path: "#",    
    component: null,
    isMainMenu:true,
    icon: <LockOutlined className="h-6 w-6"/>,
    level: 1,
    moduleId: MODULE_ACCESS_MANAGEMENT,
    children: [
      ...usersRoutes,
      //...moduleRoutes,
      //...accessRightsRoutes,    
      //...rolesRoutes,
    ]
  },
  {
    name: "Profile",
    layout: "/admin",
    path: "profile",
    component: <Profile />,
    isMainMenu:false,
  },  
];
export default routes;
